<template>
    <div>
		<div class="alert alert--danger alert--dismissible" v-if="user !== null && user.ban" role="alert">
			Ваш аккаунт заблокирован. Причина: {{ user.ban_reason ? user.ban_reason : 'не указана' }}
		</div>

        <div class="games">
            <div class="games__item" v-for="item in items" :class="item.disabled ? 'disabled' : ''">
				<img class="games__item-img" :src="item.image.src" :alt="item.image.alt">
				<div class="games__item-body">
					<h4 class="games__item-title">{{ item.text }}</h4>
					<span class="games__item-btn btn btn--block btn--white" v-if="item.disabled">Скоро</span>
					<router-link class="games__item-btn btn btn--block btn--white" v-else :to="{name: item.link}">Играть</router-link>
				</div>
            </div>
        </div>
        <AllHistory />
    </div>
</template>

<script>
    import AllHistory from "../../components/History/AllHistory.vue";
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';

    export default {
        components: {
            AllHistory
        },
        data() {
            return {
                items: [
                    {
                        text: 'Dice',
                        link: 'dice',
                        image: {
                            src: '/assets/avocado/images/dice.png',
                            alt: 'dice'
                        },
                        icon: 'dice',
                        disabled: false
                    },
                    {
                        text: 'Mines',
                        link: 'mines',
                        image: {
                            src: '/assets/avocado/images/mines.png',
                            alt: 'mines'
                        },
                        icon: 'mines',
                        disabled: false
                    },
                    {
                        text: 'Slots',
                        link: 'slots',
                        image: {
                            src: '/assets/avocado/images/casino.png',
                            alt: 'slots'
                        },
                        icon: 'slots',
                        disabled: false
                    },
                    {
                        text: 'Live',
                        link: 'live',
                        image: {
                            src: '/assets/avocado/images/live.png',
                            alt: 'live'
                        },
                        icon: 'live',
                        disabled: false
                    },
                    {
                        text: 'Coin',
                        link: 'coinflip',
                        image: {
                            src: '/assets/avocado/images/coin.png',
                            alt: 'coin'
                        },
                        icon: 'coin',
                        disabled: false
                    },
                    {
                        text: 'Wheel',
                        link: 'wheel',
                        image: {
                            src: '/assets/avocado/images/wheel.png',
                            alt: 'wheel'
                        },
                        icon: 'wheel',
                        disabled: true
                    }
			    ]
            }
        },
		computed: {
			...mapState(useUserStore, ['user'])
		}
    }
</script>
